import connect from 'react-redux/es/connect/connect';

import * as actions from '../actions/UsersTableActions';
import UsersTable from '../components/UsersTable'

const mapStateToProps = (state, ownProps) => {
    return {
        table: state.usersTable.table,
        users: state.usersTable.users,
        selectedUsers: state.usersTable.selectedUsers,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        actionLoadUsers: (sort, dir) => (dispatch(actions.loadUsers(sort, dir))),
        onUserSelect: (data) => {
            if (Array.isArray(data)) {
                dispatch(actions.selectUsers(data));

                return;
            }

            dispatch(actions.selectUser(data));
            dispatch(actions.loadUser(data));
        },
        actionLoadColumns: () => (dispatch(actions.loadColumnsWidth())),
        actionSaveColumn: (newResized) => (dispatch(actions.saveColumnWidth(newResized)))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersTable);

